import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import styles from '../Category.module.sass';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import BREAKPOINTS from '../../../constants/breakpoints';

function CategoryBlock(props) {
  const {
    setCategory, selectedCategory, category, mobileImage, desktopImage, editable,
  } = props;

  const inputRef = useRef(null);

  const onClick = () => {
    setCategory(category);

    if (!editable) { return; }

    inputRef.current.focus();
  };

  const onInputChange = (event) => {
    setCategory(event.target.value);
  };

  return (
    <ClickableDiv
      className={`${styles.block} ${(selectedCategory === category) && styles.active}`}
      onClick={onClick}
    >
      <div className={styles.icon}>
        <MediaQuery query={`(max-width: ${BREAKPOINTS.DESKTOP_WIDTH_BREAKPOINT - 1}px)`}>
          <img src={mobileImage} alt={category} />
        </MediaQuery>
        <MediaQuery query={`(min-width: ${BREAKPOINTS.DESKTOP_WIDTH_BREAKPOINT}px)`}>
          <img src={desktopImage} alt={category} />
        </MediaQuery>
      </div>
      { !editable && (
        <div className={styles.name}>
          {category}
        </div>
      )}
      { editable && (
        <input type="text" ref={inputRef} placeholder="Other,Type Here" value={category} onChange={onInputChange} />
      )}
    </ClickableDiv>
  );
}

CategoryBlock.propTypes = {
  setCategory: PropTypes.func.isRequired,
  selectedCategory: PropTypes.string,
  category: PropTypes.string.isRequired,
  mobileImage: PropTypes.string.isRequired,
  desktopImage: PropTypes.string.isRequired,
  editable: PropTypes.bool,
};

export default CategoryBlock;
